import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, OutlinedInput } from "@mui/material";

export default function SearchBar(props: { value: string; onChange: (value: string) => void }) {
  const { value, onChange } = props;
  return (
    <OutlinedInput
      className="w-full"
      startAdornment={<SearchIcon />}
      endAdornment={
        value && (
          <IconButton aria-label="delete" size="small" onClick={() => onChange("")}>
            <CloseIcon />
          </IconButton>
        )
      }
      aria-describedby="outlined-weight-helper-text"
      inputProps={{
        "aria-label": "weight",
      }}
      placeholder="Search Credit Cards"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
